// FILECONTENT_START src/common/components/Inputs/DatePicker/index.ts
import DatePicker from "./DatePicker";
export default DatePicker;
export type { DatePickerProps } from "./DatePicker";

// FILECONTENT_END src/common/components/Inputs/DatePicker/index.ts